import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  height: 100%;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  padding-top: 8px;
`;

const Label = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
`;

const SubLabel = styled.div`
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
  margin-top: 4px;
`;

export default function TicketCountModule() {
  return (
    <Container>
      <Row>
        <div>
          <Label>Final ticket count</Label>
          <SubLabel>(finals)</SubLabel>
        </div>
        <div style={{ textAlign: 'right' }}>
          <Label>Current ticket count</Label>
        </div>
      </Row>
    </Container>
  );
}


